var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { SvgIcon } from '@mui/material';
import { upsertRatioBillingDetailsUrl } from '../../../api/url';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { StatusEnum } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { showError, showNotification } from '../../../redux/commonSlice';
import { getListAPI, setReducerState } from '../../../redux/crudSlice';
import { store } from '../../../store/store';
import { RatioBillingPopupComponent } from '../components/ratioBillingPopup';
import { GetOrganizationTypeListAPI, getServiceTypeList, getTax, getTechnicianList, getWorkDistributionStatusList, pauseReasonListAPICall, UnitOfMeasurementList, validateQuantityAndGetTax, warrantyCasualFlagListAPI, warrantyComplaintTypeGetComplaintsAPI, warrantyServiceTypeListAPI } from '../services/apiCalls';
var dispatch = store.dispatch, getState = store.getState;
import { InfoOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';
import { REG } from '../../../utils/validationHelper';
import ChecklistDetailsPopup from '../../jobCard/partGridPopups/checklistDetailsPopup';
import IssuedQtyPopup from '../../jobCard/partGridPopups/issueQuantityPopup';
import MoreDetailsPopup from '../../jobCard/partGridPopups/moreDetailsPopup';
import TaxDetailsPopup from '../../jobCard/partGridPopups/taxDetailsPopup';
import { GridValidations, JobCardKeys } from '../services/entity';
var getStatus = function (name) {
    var _getState;
    return (_getState = getState()) === null || _getState === void 0 || (_getState = _getState.crud) === null || _getState === void 0 || (_getState = _getState.LabourStatusList) === null || _getState === void 0 || (_getState = _getState.data) === null || _getState === void 0 ? void 0 : _getState.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === name; });
};
var handleMoreDetailsPopup = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch(showSurface({
            type: 'Drawer',
            Component: MoreDetailsPopup,
            containerProps: {
                anchor: 'bottom'
            }
        }));
        return [2 /*return*/];
    });
}); };
var handleChecklistDetailsPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch(showSurface({
            type: 'Drawer',
            Component: ChecklistDetailsPopup,
            containerProps: {
                anchor: 'bottom'
            }
        }));
        return [2 /*return*/];
    });
}); };
var saveRatioBillingDetails = function (ratioData, currentRow) { return __awaiter(void 0, void 0, void 0, function () {
    var _Response$payload, ratioDataBody, requestBody, Response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ratioDataBody = ratioData.map(function (item, index) {
                    var _getState2;
                    return {
                        ServiceTypeBillingRatioSettingId: item.ServiceTypeBillingRatioSettingId,
                        "HeaderServiceTypeId": (_getState2 = getState()) === null || _getState2 === void 0 || (_getState2 = _getState2.crud) === null || _getState2 === void 0 ? void 0 : _getState2.documentDetailsGetById,
                        "LineServiceTypeId": currentRow.ServiceTypeId,
                        "EntityId": currentRow.EntityId,
                        "ChildId": currentRow.ChildId,
                        "Percentage": item.PercentageValue,
                        "IsChanged": false,
                        "ServiceTypeBillingRatioSettingSchemaId": item.SchemaId
                    };
                });
                requestBody = {
                    JobcardId: currentRow.JobCardId,
                    JobCardDetailBillingRatios: ratioDataBody
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: upsertRatioBillingDetailsUrl,
                        request: requestBody
                    }))];
            case 1:
                Response = _a.sent();
                if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "saved successfully.",
                        type: "success"
                    }));
                }
                return [2 /*return*/];
        }
    });
}); };
var handleOnSubmit = function (ratioData, rowData) { return __awaiter(void 0, void 0, void 0, function () {
    var totalPercent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                totalPercent = 0;
                ratioData === null || ratioData === void 0 || ratioData.map(function (item) {
                    totalPercent += Number(item === null || item === void 0 ? void 0 : item.PercentageValue);
                });
                if (!(totalPercent === 100)) return [3 /*break*/, 2];
                // let partsData = crud[JobCardKeys?.Parts]?.data
                // const newRows: any = partsData?.map((r: ResponseObject) => params?.id === r.id ? { ...r, RatioBilling: ratioData } : r);
                // dispatch(setReducerState({ key: JobCardKeys?.Parts, value: { data: newRows } }))
                return [4 /*yield*/, saveRatioBillingDetails(ratioData, rowData)];
            case 1:
                // let partsData = crud[JobCardKeys?.Parts]?.data
                // const newRows: any = partsData?.map((r: ResponseObject) => params?.id === r.id ? { ...r, RatioBilling: ratioData } : r);
                // dispatch(setReducerState({ key: JobCardKeys?.Parts, value: { data: newRows } }))
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                dispatch(showNotification({
                    isOpen: true,
                    message: "Ratio contribution must not exceed/less than 100%.",
                    type: "error"
                }));
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
var handleRatioDetailsPopup = function (rowData) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch(showSurface({
                    type: 'Drawer',
                    containerProps: {
                        PaperProps: {
                            sx: {
                                padding: 2,
                                width: {
                                    xs: '100%',
                                    sm: '400px'
                                }
                            }
                        },
                        anchor: 'bottom',
                        title: "Ratio billing"
                    },
                    Component: RatioBillingPopupComponent,
                    componentProps: {
                        onSubmit: function (ratioData) {
                            handleOnSubmit(ratioData, rowData);
                        },
                        rowData: rowData
                    }
                }))];
            case 1:
                result = _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var partElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 2,
        columnSpacing: 2,
        elements: [{
                type: FormItemTypes.TextInput,
                name: 'HSNSACCode',
                label: 'HSN Code :',
                xs: 12,
                disabled: true
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'ServiceTypeId',
                label: 'Service type',
                getListData: getServiceTypeList,
                apiKey: 'serviceTypeList',
                displayExpr: 'DisplayName',
                valueExpr: 'id',
                xs: 12,
                disabled: true
                // required: true
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'UnitOfMeasurementId',
                label: 'UOM',
                getListData: UnitOfMeasurementList,
                apiKey: 'UnitOfMeasurementList',
                displayExpr: 'Name',
                valueExpr: 'id',
                xs: 12,
                disabled: true
                // required: true
            }, {
                type: FormItemTypes.SearchSelect,
                label: 'Technician',
                name: 'TechnicianId',
                getListData: getTechnicianList,
                apiKey: 'technicianList',
                getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
                valueExpr: 'id',
                displayExpr: 'FirstName'
            },
            // {
            //     type: FormItemTypes.SearchSelect,
            //     name: 'Bay',
            //     label: 'Bay',
            //     value: null,
            //     xs: 12,
            // },
            {
                type: FormItemTypes.NumberInput,
                name: 'Quantity',
                label: 'Requested qty',
                value: null,
                xs: 6,
                // required: true,
                onFocus: function () {
                    dispatch(setReducerState({
                        key: JobCardKeys.DisableSubmit,
                        value: true
                    }));
                },
                validator: function (value) {
                    if (!value) {
                        return "Quantity is required";
                    }
                    if (Number(value) <= 0) {
                        "Quantity should be greater than 0";
                    }
                    if (Number(value) > 999999.99) {
                        return "Quantity cannot be greater than 999999.99";
                    }
                    return "";
                },
                onBlur: function (event, formValues, formApi) {
                    return __awaiter(this, void 0, void 0, function () {
                        var validationRules, _getState3, _getState4, _newPrice$payload, _newPrice$payload2, newPrice_1, _newPrice$payload3, _formValues$IssuedQua, _formValues$CancelQua, _formApi$handleInputC, updatedPrice_1, issuedQty, cancelQty, qty, pendingQty_1, setFormState;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!(+(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) > 0)) return [3 /*break*/, 1];
                                    formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                        return _objectSpread(_objectSpread({}, prev), {}, {
                                            Quantity: "Quantity should be greater than 0",
                                            IsError: true
                                        });
                                    });
                                    return [3 /*break*/, 5];
                                case 1:
                                    if (!(Number(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) > 999999.99)) return [3 /*break*/, 2];
                                    formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                        return _objectSpread(_objectSpread({}, prev), {}, {
                                            Quantity: "Quantity cannot be greater than 999999.99",
                                            IsError: true
                                        });
                                    });
                                    return [3 /*break*/, 5];
                                case 2:
                                    validationRules = {
                                        0: REG.validateInteger,
                                        1: REG.validateDecimalUptoOneDigit,
                                        2: REG.validateDecimalAndNonNumeric
                                    };
                                    if (!((formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision) !== undefined && validationRules[formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision])) return [3 /*break*/, 5];
                                    if (!!validationRules[formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision].test(formValues === null || formValues === void 0 ? void 0 : formValues.Quantity)) return [3 /*break*/, 3];
                                    formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                        return _objectSpread(_objectSpread({}, prev), {}, {
                                            Quantity: (formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision) === 0 ? "Enter Qty in multiple of 1" : "Up to ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.DecimalPrecision, " decimal precision is allowed"),
                                            IsError: true
                                        });
                                    });
                                    event.target.focus();
                                    return [3 /*break*/, 5];
                                case 3: return [4 /*yield*/, validateQuantityAndGetTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                        Quantity: Number(event.target.value)
                                    }), (_getState3 = getState()) === null || _getState3 === void 0 || (_getState3 = _getState3.crud) === null || _getState3 === void 0 ? void 0 : _getState3.documentDetailsGetById, (_getState4 = getState()) === null || _getState4 === void 0 || (_getState4 = _getState4.crud) === null || _getState4 === void 0 ? void 0 : _getState4.installbaseDetailsById)];
                                case 4:
                                    newPrice_1 = _a.sent();
                                    if (newPrice_1 !== null && newPrice_1 !== void 0 && (_newPrice$payload = newPrice_1.payload) !== null && _newPrice$payload !== void 0 && (_newPrice$payload = _newPrice$payload.value) !== null && _newPrice$payload !== void 0 && _newPrice$payload.data && newPrice_1 !== null && newPrice_1 !== void 0 && (_newPrice$payload2 = newPrice_1.payload) !== null && _newPrice$payload2 !== void 0 && (_newPrice$payload2 = _newPrice$payload2.value) !== null && _newPrice$payload2 !== void 0 && _newPrice$payload2.success) {
                                        updatedPrice_1 = newPrice_1 === null || newPrice_1 === void 0 || (_newPrice$payload3 = newPrice_1.payload) === null || _newPrice$payload3 === void 0 || (_newPrice$payload3 = _newPrice$payload3.value) === null || _newPrice$payload3 === void 0 ? void 0 : _newPrice$payload3.data;
                                        issuedQty = (_formValues$IssuedQua = formValues === null || formValues === void 0 ? void 0 : formValues.IssuedQuantity) !== null && _formValues$IssuedQua !== void 0 ? _formValues$IssuedQua : 0;
                                        cancelQty = (_formValues$CancelQua = formValues === null || formValues === void 0 ? void 0 : formValues.CancelQuantity) !== null && _formValues$CancelQua !== void 0 ? _formValues$CancelQua : 0;
                                        qty = Number(event.target.value) - issuedQty;
                                        pendingQty_1 = qty - cancelQty;
                                        setFormState = function () {
                                            return {
                                                SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                                    "Taxes": updatedPrice_1.Taxes,
                                                    "Rate": updatedPrice_1.Rate,
                                                    "Quantity": updatedPrice_1.Quantity,
                                                    "Amount": updatedPrice_1.Amount,
                                                    "TaxableAmount": updatedPrice_1.TaxableAmount,
                                                    "BaseAmount": updatedPrice_1.BaseAmount
                                                }),
                                                MRP: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.MRP,
                                                TaxableAmount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.TaxableAmount,
                                                Amount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.Amount,
                                                PendingQuantity: pendingQty_1 >= 0 ? pendingQty_1 : 0
                                            };
                                        };
                                        formApi === null || formApi === void 0 || (_formApi$handleInputC = formApi.handleInputChange) === null || _formApi$handleInputC === void 0 || _formApi$handleInputC.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                            setFormState: setFormState
                                        }));
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                IsError: false,
                                                Quantity: ""
                                            });
                                        });
                                    }
                                    else {
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            var _newPrice$payload4;
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                Quantity: (newPrice_1 === null || newPrice_1 === void 0 || (_newPrice$payload4 = newPrice_1.payload) === null || _newPrice$payload4 === void 0 || (_newPrice$payload4 = _newPrice$payload4.value) === null || _newPrice$payload4 === void 0 ? void 0 : _newPrice$payload4.message) || "Something went wrong",
                                                IsError: true
                                            });
                                        });
                                        event.target.focus();
                                    }
                                    _a.label = 5;
                                case 5:
                                    dispatch(setReducerState({
                                        key: JobCardKeys.DisableSubmit,
                                        value: false
                                    }));
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
            }, {
                type: FormItemTypes.Box,
                name: '',
                columnSize: 6,
                elements: [{
                        type: FormItemTypes.Box,
                        name: '',
                        display: 'flex',
                        justifyContent: 'space-between',
                        columnSize: 12,
                        mb: 0.5,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: 'IssuedQuantity',
                                children: 'Issued Quantity',
                                columnSize: 0,
                                fontSize: 'sm',
                                color: 'text.secondary',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.IconButton,
                                name: '',
                                setFieldProps: function () {
                                    return {
                                        disabled: false
                                    };
                                },
                                children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                    color: "primary",
                                    sx: {
                                        height: 20,
                                        width: 20
                                    }
                                }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                columnSize: 0,
                                sx: {
                                    p: 0
                                },
                                onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: IssuedQtyPopup,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        px: 0.5,
                                                        width: {
                                                            xs: '100%'
                                                        },
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                },
                                                anchor: 'bottom'
                                            },
                                            componentProps: {
                                                data: state
                                            }
                                        }));
                                        return [2 /*return*/];
                                    });
                                }); },
                                unsubscribeFormChange: true
                            }]
                    }, {
                        type: FormItemTypes.NumberInput,
                        name: 'IssuedQuantity',
                        label: '',
                        columnSize: 0,
                        disabled: true
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                // display: 'flex',
                columnSize: 12,
                elements: [
                    // {
                    //     type: FormItemTypes.ContainerItem,
                    //     name: '',
                    //     columnSize: 12,
                    //     spacing: 0,
                    //     justifyContent: 'space-between',
                    //     alignItems: 'end',
                    //     elements: [
                    //         {
                    //             type: FormItemTypes.Typography,
                    //             name: 'AvailableQuantity',
                    //             children: 'Available',
                    //             columnSize: 0,
                    //             color: 'text.tertiary',
                    //             fontSize: 'sm',
                    //             fontWeight: 'medium',
                    //         },
                    //         {
                    //             type: FormItemTypes.IconButton,
                    //             name: '',
                    //             children:
                    //                 <SvgIcon color='primary' sx={{ height: 20, width: 20 }}>
                    //                     <AlertIcon />,
                    //                 </SvgIcon>,
                    //             columnSize: 0,
                    //             size: 'small',
                    //             color: 'primary',
                    //             sx: { p: 0 },
                    //             onClick: async (e, state) => {
                    //                 dispatch(showSurface({
                    //                     type: 'Drawer',
                    //                     Component: AvailableStockPopUp,
                    //                     containerProps: { PaperProps: { sx: { px: 0.5, width: { xs: '100%' }, borderRadius: '8px 8px 0 0' }, }, anchor: 'bottom' },
                    //                     componentProps: { data: state }
                    //                 }));
                    //             }
                    //         },
                    //     ],
                    // },
                    // {
                    //     type: FormItemTypes.NumberInput,
                    //     name: 'AvailableQuantity',
                    //     value: null,
                    //     xs: 12,
                    //     placeholder: ' Enter available',
                    //     disabled: true,
                    //     valueGetter(formValues, value) { return formValues?.AvailableQuantity ?? 0 }
                    // },
                    {
                        type: FormItemTypes.NumberInput,
                        name: 'Rate',
                        label: 'Rate',
                        // required: true,
                        value: null,
                        disabled: true,
                        xs: 6,
                        valueGetter: function (formValues, field) {
                            var _formValues$SavedPric;
                            return formValues === null || formValues === void 0 || (_formValues$SavedPric = formValues.SavedPriceWithTax) === null || _formValues$SavedPric === void 0 ? void 0 : _formValues$SavedPric.Rate;
                        },
                        setFormState: function (formValues, value) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, {
                                        SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                            Rate: value
                                        })
                                    }];
                            });
                        }); },
                        onBlur: function (event, formValues, formApi) {
                            return __awaiter(this, void 0, void 0, function () {
                                var _getState5, _getState6, _newPrice$payload5, _newPrice$payload6, newPrice, _newPrice$payload7, _formApi$handleInputC2, updatedPrice_2, setFormState;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, validateQuantityAndGetTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                                Rate: Number(event.target.value)
                                            }), (_getState5 = getState()) === null || _getState5 === void 0 || (_getState5 = _getState5.crud) === null || _getState5 === void 0 ? void 0 : _getState5.documentDetailsGetById, (_getState6 = getState()) === null || _getState6 === void 0 || (_getState6 = _getState6.crud) === null || _getState6 === void 0 ? void 0 : _getState6.installbaseDetailsById)];
                                        case 1:
                                            newPrice = _a.sent();
                                            if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload5 = newPrice.payload) !== null && _newPrice$payload5 !== void 0 && (_newPrice$payload5 = _newPrice$payload5.value) !== null && _newPrice$payload5 !== void 0 && _newPrice$payload5.data && newPrice !== null && newPrice !== void 0 && (_newPrice$payload6 = newPrice.payload) !== null && _newPrice$payload6 !== void 0 && (_newPrice$payload6 = _newPrice$payload6.value) !== null && _newPrice$payload6 !== void 0 && _newPrice$payload6.success) {
                                                updatedPrice_2 = newPrice === null || newPrice === void 0 || (_newPrice$payload7 = newPrice.payload) === null || _newPrice$payload7 === void 0 || (_newPrice$payload7 = _newPrice$payload7.value) === null || _newPrice$payload7 === void 0 ? void 0 : _newPrice$payload7.data;
                                                setFormState = function () {
                                                    return {
                                                        SavedPriceWithTax: _objectSpread(_objectSpread({}, formValues === null || formValues === void 0 ? void 0 : formValues.SavedPriceWithTax), {}, {
                                                            "Taxes": updatedPrice_2.Taxes,
                                                            "Rate": updatedPrice_2.Rate,
                                                            "Quantity": updatedPrice_2.Quantity,
                                                            "Amount": updatedPrice_2.Amount,
                                                            "TaxableAmount": updatedPrice_2.TaxableAmount,
                                                            "BaseAmount": updatedPrice_2.BaseAmount
                                                        }),
                                                        MRP: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.MRP,
                                                        TaxableAmount: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.TaxableAmount,
                                                        Amount: updatedPrice_2 === null || updatedPrice_2 === void 0 ? void 0 : updatedPrice_2.Amount
                                                    };
                                                };
                                                formApi === null || formApi === void 0 || (_formApi$handleInputC2 = formApi.handleInputChange) === null || _formApi$handleInputC2 === void 0 || _formApi$handleInputC2.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                                    setFormState: setFormState
                                                }));
                                                formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                    return _objectSpread(_objectSpread({}, prev), {}, {
                                                        IsError: false,
                                                        Rate: ""
                                                    });
                                                });
                                            }
                                            else {
                                                formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                    var _newPrice$payload8;
                                                    return _objectSpread(_objectSpread({}, prev), {}, {
                                                        Rate: (newPrice === null || newPrice === void 0 || (_newPrice$payload8 = newPrice.payload) === null || _newPrice$payload8 === void 0 || (_newPrice$payload8 = _newPrice$payload8.value) === null || _newPrice$payload8 === void 0 ? void 0 : _newPrice$payload8.message) || "Something went wrong",
                                                        IsError: true
                                                    });
                                                });
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        },
                        // validator(value, state) {
                        //     let minPrice = state?.SavedPriceWithTax?.MinPrice;
                        //     let maxPrice = state?.SavedPriceWithTax?.MaxPrice;
                        //     // If MinPrice or MaxPrice is null, undefined, or not a valid number, skip validation
                        //     let isValidMin = typeof minPrice === 'number' && !isNaN(minPrice);
                        //     let isValidMax = typeof maxPrice === 'number' && !isNaN(maxPrice);
                        //     if (!isValidMin) {
                        //         minPrice = 0
                        //         isValidMin = true
                        //     }
                        //     if (!isValidMax) {
                        //         maxPrice = state?.OriginalPrice
                        //         isValidMax = true
                        //     }
                        //     if (isValidMin && value < minPrice) {
                        //         return `Rate should be minimum ${minPrice}`;
                        //     }
                        //     if (isValidMax && value > maxPrice) {
                        //         return `Rate should not be greater than ${maxPrice}`;
                        //     }
                        //     return undefined;
                        // },
                        setFieldProps: function (state, currValue, field) {
                            // let isRateDisable = true
                            // if (state?.IsAutoFill) {
                            //     isRateDisable = true
                            // }
                            // if (state?.SavedPriceWithTax?.IsRateEditable) {
                            //     isRateDisable = false
                            // }
                            return {
                                disabled: true,
                                onChange: function () { }
                            };
                        }
                    }, {
                        type: FormItemTypes.SearchSelect,
                        name: 'MRP',
                        label: 'MRP',
                        // value: null,
                        xs: 6,
                        valueGetter: function (formValues, value) {
                            var _formValues$SavedPric2, _formValues$SavedPric3;
                            return (_formValues$SavedPric2 = formValues === null || formValues === void 0 || (_formValues$SavedPric3 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric3 === void 0 ? void 0 : _formValues$SavedPric3.MRP) !== null && _formValues$SavedPric2 !== void 0 ? _formValues$SavedPric2 : 0;
                        },
                        valueExpr: 'MRP',
                        displayExpr: "MRP",
                        // apiKey: "MRPList",
                        // getListData: async (params) => {
                        //     dispatch((setReducerState({ key: 'MRPList', value: { data: params?.state?.PriceWithTaxList || [], success: true } })))
                        //     return { success: true }
                        // },
                        setFormState: function (formValues, current) {
                            return {
                                SavedPriceWithTax: current,
                                MRP: current === null || current === void 0 ? void 0 : current.MRP,
                                TaxableAmount: current === null || current === void 0 ? void 0 : current.TaxableAmount,
                                Amount: current === null || current === void 0 ? void 0 : current.Amount,
                                Rate: current === null || current === void 0 ? void 0 : current.Rate
                            };
                        },
                        setFieldProps: function (state, currValue, field) {
                            return {
                                type: FormItemTypes.SearchSelect,
                                disabled: (currValue === null || currValue === void 0 ? void 0 : currValue.PriceGroupCategoryKey) !== "MRP",
                                options: (state === null || state === void 0 ? void 0 : state.PriceWithTaxList) || []
                            };
                        }
                    }
                ]
            }, {
                type: FormItemTypes.Box,
                name: '',
                // display: 'flex',
                columnSize: 12,
                elements: [
                    // only UAT v2.5
                    // {
                    //     type: FormItemTypes.Box,
                    //     name: '',
                    //     display: 'flex',
                    //     justifyContent: 'space-between',
                    //     columnSize: 12,
                    //     elements: [
                    //         {
                    //             type: FormItemTypes.Typography,
                    //             name: 'Price',
                    //             children: 'Amount',
                    //             columnSize: 0,
                    //             color: '#6A7682',
                    //             fontSize: 'sm',
                    //             fontWeight: 'medium'
                    //         },
                    //         {
                    //             type: FormItemTypes.Button,
                    //             name: '',
                    //             variant: 'text',
                    //             children: 'Ratio',
                    //             columnSize: 0,
                    //             sx: {
                    //                 pt: 0
                    //             },
                    //             onClick: (e, formValues, api) => {
                    //                 handleRatioDetailsPopup(formValues)
                    //             },
                    //             setFieldProps(formValues, currValue) {
                    //                 return {
                    //                     disabled: false,
                    //                     sx: {
                    //                         display: formValues.RatioBilling?.length > 0 ? 'inline-flex' : 'none',
                    //                         pt: 0
                    //                     }
                    //                 }
                    //             },
                    //         },
                    //     ],
                    // },
                    {
                        type: FormItemTypes.NumberInput,
                        name: 'Amount',
                        value: null,
                        placeholder: 'Enter Amount',
                        xs: 12,
                        disabled: true
                    }
                ]
            },
            // only UAT v2.5
            // {
            //     type: FormItemTypes.NumberInput,
            //     name: 'TradeDiscountPercentage',
            //     label: 'Trade Discount (₹) :',
            //     value: null,
            //     disabled: true,
            //     xs: 6,
            //     InputProps: {
            //         endAdornment: <SvgIcon sx={{ height: 20, width: 20 }}>
            //             <DeviderIcon />
            //         </SvgIcon>
            //     }
            // },
            // {
            //     type: FormItemTypes.NumberInput,
            //     name: 'TradeDiscountAmount',
            //     label: '',
            //     value: null,
            //     disabled: true,
            //     sx: { marginTop: '22px' },
            //     xs: 6,
            //     InputProps: {
            //         endAdornment: <SvgIcon sx={{ height: 20, width: 20 }}>
            //             <RupeeIcon />
            //         </SvgIcon>
            //     }
            // },
            {
                type: FormItemTypes.NumberInput,
                name: 'TaxableAmount',
                label: 'Taxable amount (₹) ',
                value: null,
                xs: 6,
                disabled: true
            }, {
                type: FormItemTypes.Box,
                name: '',
                columnSize: 6,
                elements: [{
                        type: FormItemTypes.Box,
                        name: '',
                        display: 'flex',
                        justifyContent: 'space-between',
                        columnSize: 12,
                        mb: 0.4,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                children: 'Total taxes (₹)',
                                columnSize: 0,
                                fontSize: 'sm',
                                color: 'text.secondary',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.IconButton,
                                name: '',
                                children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                    color: "primary",
                                    sx: {
                                        height: 20,
                                        width: 20
                                    }
                                }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                columnSize: 0,
                                sx: {
                                    p: 0
                                },
                                setFieldProps: function () {
                                    return {
                                        disabled: false
                                    };
                                },
                                onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: TaxDetailsPopup,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        px: 0.5,
                                                        width: {
                                                            xs: '100%'
                                                        },
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                },
                                                anchor: 'bottom'
                                            },
                                            componentProps: {
                                                data: state
                                            }
                                        }));
                                        return [2 /*return*/];
                                    });
                                }); },
                                unsubscribeFormChange: true
                            }]
                    }, {
                        type: FormItemTypes.NumberInput,
                        name: 'Totaltaxes',
                        label: '',
                        columnSize: 0,
                        disabled: true,
                        sx: {
                            p: 0
                        },
                        valueGetter: function (formValues, field) {
                            var _formValues$SavedPric4;
                            var totalTax = 0;
                            formValues === null || formValues === void 0 || (_formValues$SavedPric4 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric4 === void 0 || (_formValues$SavedPric4 = _formValues$SavedPric4.Taxes) === null || _formValues$SavedPric4 === void 0 || _formValues$SavedPric4.forEach(function (taxItem) {
                                totalTax += taxItem.TaxComponentAmount;
                            });
                            var displayValue = totalTax > 0 ? totalTax.toFixed(2) : 0;
                            return displayValue;
                        }
                    }]
            }
            // only UAT v2.5
            // {
            //     type: FormItemTypes.Box,
            //     name: '',
            //     display: 'flex',
            //     justifyContent: 'end',
            //     gap: '16px',
            //     columnSize: 12,
            //     elements: [
            //         {
            //             type: FormItemTypes.Button,
            //             name: '',
            //             variant: 'outlined',
            //             children: 'Checksheet',
            //             columnSize: 0,
            //             onClick: async () => {
            //                 const result = await dispatch(showSurface({
            //                     type: 'Drawer',
            //                     Component: ChecklistDetailsPopup,
            //                     containerProps: {
            //                         anchor: 'bottom',
            //                         PaperProps: {
            //                             sx: {
            //                                 borderRadius: '8px 8px 0 0'
            //                             }
            //                         }
            //                     },
            //                 }));
            //             }
            //         },
            //         {
            //             type: FormItemTypes.Button,
            //             name: '',
            //             variant: 'outlined',
            //             children: 'View more',
            //             columnSize: 0,
            //             setFormState: async (state) => {
            //                 const res = await dispatch(showSurface({
            //                     type: 'Drawer',
            //                     Component: PartMoreDetails,
            //                     containerProps: {
            //                         anchor: 'bottom',
            //                         PaperProps: {
            //                             sx: {
            //                                 borderRadius: '8px 8px 0 0'
            //                             }
            //                         }
            //                     },
            //                     componentProps: {
            //                         data: state,
            //                     }
            //                 }));
            //                 if (res?.payload) {
            //                     return {
            //                         ...res?.payload
            //                     }
            //                 }
            //             }
            //         }],
            // },
        ],
        columnSize: 12
    }];
export var labourElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 2,
        columnSpacing: 2,
        columnSize: 12,
        elements: [{
                type: FormItemTypes.TextInput,
                name: 'Description',
                label: 'Description :',
                minRows: 4,
                value: null,
                disabled: true,
                multiline: true,
                xs: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'HSNSACCode',
                label: 'SAC Code :',
                xs: 12,
                disabled: true
            }, {
                type: FormItemTypes.NumberInput,
                name: 'Rate',
                label: 'Rate',
                value: null,
                xs: 6,
                valueGetter: function (formValues, field) {
                    var _formValues$SavedPric5;
                    return formValues === null || formValues === void 0 || (_formValues$SavedPric5 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric5 === void 0 ? void 0 : _formValues$SavedPric5.Rate;
                },
                validator: function (value, updates) {
                    if (value != 0 && !value) {
                        return "This field is required";
                    }
                    if (updates !== null && updates !== void 0 && updates.MaxPrice && value > (updates === null || updates === void 0 ? void 0 : updates.MaxPrice)) {
                        return "Rate should be less than ".concat(updates === null || updates === void 0 ? void 0 : updates.MaxPrice);
                    }
                    if (updates !== null && updates !== void 0 && updates.OriginalPrice && value > (updates === null || updates === void 0 ? void 0 : updates.OriginalPrice)) {
                        return "Rate can not be greater than ".concat(updates === null || updates === void 0 ? void 0 : updates.OriginalPrice);
                    }
                    if (updates !== null && updates !== void 0 && updates.MinPrice && value < (updates === null || updates === void 0 ? void 0 : updates.MinPrice)) {
                        return "Rate should be more than ".concat(updates === null || updates === void 0 ? void 0 : updates.MinPrice);
                    }
                    if (!REG.validateDecimalAndNonNumeric.test(value) && value !== "") {
                        return "Up to 2 decimal precision is allowed";
                    }
                    return "";
                },
                setFieldProps: function (state, currValue, field) {
                    var _getState7, _state$SavedPriceWith, _state$SavedPriceWith2;
                    var isDisabledBasedOnStatus = [StatusEnum.Delivered, StatusEnum.Cancelled, StatusEnum.ReadyForInvoice, StatusEnum.Awaiting, StatusEnum.Invoiced, StatusEnum.FinalInspection].includes(((_getState7 = getState()) === null || _getState7 === void 0 || (_getState7 = _getState7.crud) === null || _getState7 === void 0 || (_getState7 = _getState7.documentDetailsGetById) === null || _getState7 === void 0 || (_getState7 = _getState7.data) === null || _getState7 === void 0 ? void 0 : _getState7.Key) || "");
                    var isRateEditable = typeof ((state === null || state === void 0 ? void 0 : state.SavedPriceWithTax) && (state === null || state === void 0 || (_state$SavedPriceWith = state.SavedPriceWithTax) === null || _state$SavedPriceWith === void 0 ? void 0 : _state$SavedPriceWith.IsRateEditable)) === 'boolean' ? state === null || state === void 0 || (_state$SavedPriceWith2 = state.SavedPriceWithTax) === null || _state$SavedPriceWith2 === void 0 ? void 0 : _state$SavedPriceWith2.IsRateEditable : false;
                    var isRateDisable = !isRateEditable;
                    return {
                        type: FormItemTypes.NumberInput,
                        disabled: isDisabledBasedOnStatus || isRateDisable
                    };
                },
                onFocus: function () {
                    dispatch(setReducerState({
                        key: JobCardKeys.DisableSubmit,
                        value: true
                    }));
                },
                onBlur: function (event, formValues, formApi) {
                    return __awaiter(this, void 0, void 0, function () {
                        var _getState8, _formValues$IssuedQua2, _formValues$CancelQua2, _newPrice$payload9, _newPrice$payload10, newPrice, issuedQty, cancelQty, qty, pendingQty, _newPrice$payload11, _updatedPrice$Taxes, _updatedPrice$Taxes2, _updatedPrice$Taxes3, _formApi$handleInputC3, updatedPrice_3, IGST_1, CGST_1, SGST_1, setFormState;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (Number(event.target.value) === 0) {
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                                            Rate: "Rate can not be 0",
                                            IsError: true
                                        }); });
                                        event.target.focus();
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, getTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                            Rate: Number(event.target.value)
                                        }), (_getState8 = getState()) === null || _getState8 === void 0 || (_getState8 = _getState8.crud) === null || _getState8 === void 0 ? void 0 : _getState8.documentDetailsGetById)];
                                case 1:
                                    newPrice = _a.sent();
                                    issuedQty = (_formValues$IssuedQua2 = formValues === null || formValues === void 0 ? void 0 : formValues.IssuedQuantity) !== null && _formValues$IssuedQua2 !== void 0 ? _formValues$IssuedQua2 : 0;
                                    cancelQty = (_formValues$CancelQua2 = formValues === null || formValues === void 0 ? void 0 : formValues.CancelQuantity) !== null && _formValues$CancelQua2 !== void 0 ? _formValues$CancelQua2 : 0;
                                    qty = Number(event.target.value) - issuedQty;
                                    pendingQty = qty - cancelQty;
                                    if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload9 = newPrice.payload) !== null && _newPrice$payload9 !== void 0 && (_newPrice$payload9 = _newPrice$payload9.value) !== null && _newPrice$payload9 !== void 0 && _newPrice$payload9.data && newPrice !== null && newPrice !== void 0 && (_newPrice$payload10 = newPrice.payload) !== null && _newPrice$payload10 !== void 0 && (_newPrice$payload10 = _newPrice$payload10.value) !== null && _newPrice$payload10 !== void 0 && _newPrice$payload10.success) {
                                        updatedPrice_3 = newPrice === null || newPrice === void 0 || (_newPrice$payload11 = newPrice.payload) === null || _newPrice$payload11 === void 0 || (_newPrice$payload11 = _newPrice$payload11.value) === null || _newPrice$payload11 === void 0 ? void 0 : _newPrice$payload11.data;
                                        IGST_1 = updatedPrice_3 === null || updatedPrice_3 === void 0 || (_updatedPrice$Taxes = updatedPrice_3.Taxes) === null || _updatedPrice$Taxes === void 0 ? void 0 : _updatedPrice$Taxes.find(function (item) { return item.TaxComponentName === "IGST"; });
                                        CGST_1 = updatedPrice_3 === null || updatedPrice_3 === void 0 || (_updatedPrice$Taxes2 = updatedPrice_3.Taxes) === null || _updatedPrice$Taxes2 === void 0 ? void 0 : _updatedPrice$Taxes2.find(function (item) { return item.TaxComponentName === "CGST"; });
                                        SGST_1 = updatedPrice_3 === null || updatedPrice_3 === void 0 || (_updatedPrice$Taxes3 = updatedPrice_3.Taxes) === null || _updatedPrice$Taxes3 === void 0 ? void 0 : _updatedPrice$Taxes3.find(function (item) { return item.TaxComponentName === "SGST"; });
                                        setFormState = function (state) {
                                            var _state$SavedPriceWith3;
                                            return {
                                                IsPriceUpdate: true,
                                                SavedPriceWithTax: _objectSpread(_objectSpread({}, state.SavedPriceWithTax), {}, {
                                                    "Taxes": updatedPrice_3.Taxes,
                                                    "Rate": updatedPrice_3.Rate,
                                                    "Quantity": updatedPrice_3.Quantity,
                                                    "Amount": updatedPrice_3.Amount,
                                                    "TaxableAmount": updatedPrice_3.TaxableAmount,
                                                    "BaseAmount": updatedPrice_3.BaseAmount
                                                }),
                                                MRP: updatedPrice_3 === null || updatedPrice_3 === void 0 ? void 0 : updatedPrice_3.MRP,
                                                TaxableAmount: updatedPrice_3 === null || updatedPrice_3 === void 0 ? void 0 : updatedPrice_3.TaxableAmount,
                                                Amount: updatedPrice_3 === null || updatedPrice_3 === void 0 ? void 0 : updatedPrice_3.Amount,
                                                Rate: updatedPrice_3 === null || updatedPrice_3 === void 0 ? void 0 : updatedPrice_3.Rate,
                                                SGST_UTGST_Amount: SGST_1 ? SGST_1 === null || SGST_1 === void 0 ? void 0 : SGST_1.TaxComponentAmount : 0,
                                                SGST_UTGST_Percentage: SGST_1 ? SGST_1 === null || SGST_1 === void 0 ? void 0 : SGST_1.TaxComponentPercentage : 0,
                                                CGSTAmount: CGST_1 ? CGST_1.TaxComponentAmount : 0,
                                                CGSTPercentage: CGST_1 ? CGST_1.TaxComponentPercentage : 0,
                                                IGSTAmount: IGST_1 ? IGST_1 === null || IGST_1 === void 0 ? void 0 : IGST_1.TaxComponentAmount : 0,
                                                IGSTPercentage: IGST_1 ? IGST_1.TaxComponentPercentage : 0,
                                                PriceGroupCategoryKey: updatedPrice_3.PriceGroupCategoryKey || (state === null || state === void 0 || (_state$SavedPriceWith3 = state.SavedPriceWithTax) === null || _state$SavedPriceWith3 === void 0 ? void 0 : _state$SavedPriceWith3.PriceGroupCategoryKey),
                                                PendingQuantity: pendingQty >= 0 ? pendingQty : 0,
                                                error: undefined
                                            };
                                        };
                                        formApi === null || formApi === void 0 || (_formApi$handleInputC3 = formApi.handleInputChange) === null || _formApi$handleInputC3 === void 0 || _formApi$handleInputC3.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                            setFormState: setFormState
                                        }));
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                IsError: false,
                                                Rate: ""
                                            });
                                        });
                                    }
                                    else {
                                        formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                            var _newPrice$payload12;
                                            return _objectSpread(_objectSpread({}, prev), {}, {
                                                Rate: (newPrice === null || newPrice === void 0 || (_newPrice$payload12 = newPrice.payload) === null || _newPrice$payload12 === void 0 || (_newPrice$payload12 = _newPrice$payload12.value) === null || _newPrice$payload12 === void 0 ? void 0 : _newPrice$payload12.message) || "Something went wrong",
                                                IsError: true
                                            });
                                        });
                                        event.target.focus();
                                    }
                                    dispatch(setReducerState({
                                        key: JobCardKeys.DisableSubmit,
                                        value: false
                                    }));
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
            }, {
                type: FormItemTypes.NumberInput,
                name: 'Quantity',
                label: 'Unit',
                value: null,
                xs: 6,
                disabled: true,
                // validator(value, state) {
                //     let message = '';
                //     if (!value) return message;
                //     switch (state?.StatusName) {
                //         case StatusEnum.Completed:
                //             message = GridValidations.WORK_COMPLETED;
                //             break;
                //         case StatusEnum.Pause:
                //             message = GridValidations.LABOUR_PAUSED;
                //             break;
                //         default:
                //             if (!state?.HSNSACCode)
                //                 message = GridValidations.SAC_REQUIRED;
                //             break;
                //     }
                //     return message;
                // },
                setFormState: function (formValues, value) {
                    return {
                        Amount: (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * value,
                        TaxAmount: (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * value
                    };
                }
            },
            // {
            //     type: FormItemTypes.SearchSelect,
            //     name: 'UnitOfMeasurementId',
            //     label: 'UOM',
            //     getListData: UnitOfMeasurementList,
            //     apiKey: 'UnitOfMeasurementList',
            //     displayExpr: 'Name',
            //     valueExpr: 'id',
            //     xs: 12,
            //     disabled: true
            // },
            {
                type: FormItemTypes.SearchSelect,
                name: 'ServiceTypeId',
                label: 'Service type',
                getListData: getServiceTypeList,
                apiKey: 'serviceTypeList',
                displayExpr: 'DisplayName',
                valueExpr: 'id',
                xs: 12,
                disabled: true
                // required: true
            }, {
                type: FormItemTypes.SearchSelect,
                label: 'Technician',
                name: 'TechnicianId',
                getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
                validator: function (value, updates) {
                    var message = '';
                    if (!value) {
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Started) {
                            return "You cannont clear 'Technician Name' since status is started.";
                        }
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                            return GridValidations.WORK_COMPLETED;
                        }
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                            return GridValidations.LABOUR_PAUSED;
                        }
                        return message;
                    }
                    if (value === (updates === null || updates === void 0 ? void 0 : updates.TechnicianId))
                        return message;
                    switch (updates === null || updates === void 0 ? void 0 : updates.StatusName) {
                        case StatusEnum.Completed:
                            message = GridValidations.WORK_COMPLETED;
                            break;
                        case StatusEnum.Pause:
                            message = GridValidations.LABOUR_PAUSED;
                            break;
                        default:
                            if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                                message = GridValidations.SAC_REQUIRED;
                            break;
                    }
                    return message;
                },
                valueSetter: function (formValue, currValue) {
                    var _currValue$id;
                    if ((formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) === StatusEnum.Completed) {
                        dispatch(showError(GridValidations.WORK_COMPLETED));
                        return {
                            TechnicianName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianName,
                            TechnicianId: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianId,
                            TechnicianFamilyName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianFamilyName
                        };
                    }
                    if ((formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) === StatusEnum.Pause) {
                        dispatch(showError(GridValidations.LABOUR_PAUSED));
                        return {
                            TechnicianName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianName,
                            TechnicianId: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianId,
                            TechnicianFamilyName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianFamilyName
                        };
                    }
                    if (!formValue) {
                        return _objectSpread(_objectSpread({}, formValue), {}, {
                            ServiceStartDateTime: null,
                            ServiceEndDateTime: null,
                            TechnicianName: null,
                            TechnicianId: null,
                            TechnicianFamilyName: null
                        });
                    }
                    return _objectSpread(_objectSpread({}, formValue), {}, {
                        TechnicianName: currValue === null || currValue === void 0 ? void 0 : currValue.FirstName,
                        TechnicianFamilyName: currValue === null || currValue === void 0 ? void 0 : currValue.LastName,
                        TechnicianId: (_currValue$id = currValue === null || currValue === void 0 ? void 0 : currValue.id) !== null && _currValue$id !== void 0 ? _currValue$id : null
                    });
                },
                getListData: getTechnicianList,
                apiKey: 'technicianList',
                valueExpr: 'id',
                displayExpr: 'FirstName'
            },
            // {
            //     type: FormItemTypes.NumberInput,
            //     name: 'Requestedqty',
            //     label: 'Requested qty',
            //     value: null,
            //     xs: 6,
            //     setFieldProps: (state) => ({
            //         type: FormItemTypes.NumberInput,
            //     })
            // },
            {
                type: FormItemTypes.DateTimePicker,
                name: 'ServiceStartDateTime',
                label: 'Start date & time:',
                value: null,
                xs: 12,
                valueSetter: function (formValue, currValue) {
                    switch (formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) {
                        case StatusEnum.Completed:
                            dispatch(showError(GridValidations.WORK_COMPLETED));
                            return {
                                ServiceStartDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceStartDateTime
                            };
                        case StatusEnum.Pause:
                            dispatch(showError(GridValidations.LABOUR_PAUSED));
                            return {
                                ServiceStartDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceStartDateTime
                            };
                        case StatusEnum.Awaiting:
                            dispatch(showError(GridValidations.LABOUR_AWAITING));
                            return {
                                ServiceStartDateTime: null
                            };
                    }
                },
                validator: function (value, updates) {
                    var _dayjs;
                    var message = '';
                    var previousStartDate = dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceStartDateTime);
                    var currStartDate = dayjs(value);
                    if (!value) {
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Start) {
                            return "You cannot clear the 'Date and time' since work is already started.";
                        }
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                            return "You cannot clear the 'Date and time' since work is paused.";
                        }
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                            return "You cannot clear the 'Date and time' since work is completed.";
                        }
                        return message;
                    }
                    if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                        message = GridValidations.SAC_REQUIRED;
                    if (updates !== null && updates !== void 0 && updates.JCCreationDate && (_dayjs = dayjs(value)) !== null && _dayjs !== void 0 && _dayjs.isBefore(dayjs(updates === null || updates === void 0 ? void 0 : updates.JCCreationDate)))
                        message = "Start date time should be greater than document creation date time.";
                    if (dayjs(value).isAfter(dayjs()))
                        message = "Labor start date time can not be greater than actual date time.";
                    // switch (updates?.StatusName) {
                    // case StatusEnum.Completed:
                    //     if (currStartDate?.isSame(previousStartDate, 'minute')) {
                    //         return message;
                    //     }
                    //     message = `You cannot change the 'Date and time' since work is completed. ( Start time: ${previousStartDate && previousStartDate?.format('DD MMM, YYYY h:mm A')} )`;
                    //     break;
                    // case StatusEnum.Pause:
                    //     if (currStartDate?.isSame(previousStartDate, 'minute')) {
                    //         return message;
                    //     }
                    //     message = `You cannot change the 'Date and time' since work is paused. ( Start time: ${previousStartDate && previousStartDate?.format('DD MMM, YYYY h:mm A')} )`;
                    //     break;
                    // case StatusEnum.Awaiting:
                    //     message = GridValidations.LABOUR_AWAITING;
                    //     break;
                    // default:
                    // if (!updates?.HSNSACCode)
                    //     message = GridValidations.SAC_REQUIRED;
                    // if (updates?.JCCreationDate && dayjs(value)?.isBefore(dayjs(updates?.JCCreationDate)))
                    //     message = "Start date time should be greater than document creation date time.";
                    // if ((dayjs(value).isAfter(dayjs())))
                    //     message = "Labor start date time can not be greater than actual date time.";
                    //     break;
                    // }
                    return message;
                },
                disableFuture: true,
                setFieldProps: function (formValues) {
                    return {
                        disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Awaiting,
                        maxDateTime: formValues !== null && formValues !== void 0 && formValues.ServiceEndDateTime ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ServiceEndDateTime) : undefined
                    };
                }
            }, {
                type: FormItemTypes.DateTimePicker,
                name: 'ServiceEndDateTime',
                label: 'End date & time:',
                value: null,
                xs: 12,
                valueSetter: function (formValue, currValue) {
                    switch (formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) {
                        case StatusEnum.Completed:
                            dispatch(showError(GridValidations.WORK_COMPLETED));
                            return _objectSpread(_objectSpread({}, formValue), {}, {
                                ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                            });
                        case StatusEnum.Pause:
                            dispatch(showError(GridValidations.LABOUR_PAUSED));
                            return {
                                ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                            };
                        case StatusEnum.Awaiting:
                            dispatch(showError(GridValidations.LABOUR_AWAITING));
                            return {
                                ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                            };
                    }
                },
                setFieldProps: function (formValues) {
                    return {
                        minDateTime: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ServiceStartDateTime),
                        disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Awaiting
                    };
                },
                validator: function (value, updates) {
                    var _dayjs2;
                    var message = '';
                    var previousEndDate = dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceEndDateTime);
                    var currEndDate = dayjs(value);
                    if (!value) {
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                            return "You cannot clear the 'Date and time' since work is paused.";
                        }
                        if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                            return "You cannot clear the 'Date and time' since work is completed.";
                        }
                        return message;
                    }
                    switch (updates === null || updates === void 0 ? void 0 : updates.StatusName) {
                        case StatusEnum.Completed:
                            if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                                return message;
                            }
                            message = "You cannot change the 'Date and time' since work is completed. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                            break;
                        case StatusEnum.Pause:
                            if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                                return message;
                            }
                            message = "You cannot change the 'Date and time' since work is paused. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                            break;
                        case StatusEnum.Awaiting:
                            message = GridValidations.LABOUR_AWAITING;
                            break;
                        case StatusEnum.Start:
                            message = GridValidations.DATE_VALIDATION;
                            break;
                        default:
                            if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                                message = GridValidations.SAC_REQUIRED;
                            if ((_dayjs2 = dayjs(value)) !== null && _dayjs2 !== void 0 && _dayjs2.isBefore(dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceStartDateTime), 'minute')) {
                                message = "End date time cannot be earlier than start date time";
                            }
                            else if (dayjs(value).isAfter(dayjs(), 'minute') && !dayjs(value).isSame(dayjs(), 'day')) {
                                message = "Post dated transaction not allowed";
                            }
                            break;
                    }
                    return message;
                }
            },
            // only UAT v2.5
            // {
            //     type: FormItemTypes.TextInput,
            //     name: 'TradeDiscountPercentage',
            //     label: 'Trade Discount ',
            //     disabled: true,
            //     value: null,
            //     xs: 4,
            // },
            // {
            //     type: FormItemTypes.TextInput,
            //     name: 'TradeDiscountAmount',
            //     label: '',
            //     disabled: true,
            //     value: null,
            //     xs: 8,
            //     sx: {
            //         mt: '20px'
            //     }
            // },
            {
                type: FormItemTypes.NumberInput,
                name: 'TaxableAmount',
                label: 'Taxable amount (₹) ',
                value: null,
                xs: 6,
                disabled: true
            },
            // {
            //     type: FormItemTypes.Box,
            //     name: '',
            //     columnSize: 6,
            //     display: 'flex',
            //     flexDirection: 'column',
            //     //   gap:'8px',
            //     elements: [
            //         {
            //             type: FormItemTypes.Box,
            //             name: '',
            //             display: 'flex',
            //             justifyContent: 'space-between',
            //             columnSize: 12,
            //             elements: [
            //                 {
            //                     type: FormItemTypes.Typography,
            //                     name: '',
            //                     value: 'Total taxes (₹)',
            //                     columnSize: 0,
            //                     color: 'text.secondary',
            //                     fontSize: 'sm',
            //                     fontWeight: 'sm'
            //                 },
            //                 {
            //                     type: FormItemTypes.IconButton,
            //                     name: '',
            //                     children: <AlertIcon color='info.main' height={'20px'} width={'20px'} />,
            //                     columnSize: 0,
            //                     onClick: async (e, state) => {
            //                         dispatch(showSurface({
            //                             type: 'Drawer',
            //                             Component: TaxDetailsPopup,
            //                             containerProps: { PaperProps: { sx: { px: 0.5, width: { xs: '100%' }, borderRadius: '8px 8px 0 0' }, }, anchor: 'bottom' },
            //                             componentProps: { data: state }
            //                         }));
            //                     }
            //                 },
            //             ],
            //         },
            //         {
            //             type: FormItemTypes.TextInput,
            //             name: 'Totalamount',
            //             value: null,
            //             xs: 12,
            //             sx:{
            //                 mt:'-8px'
            //             }
            //         },
            //     ],
            // },
            {
                type: FormItemTypes.Box,
                name: '',
                columnSize: 6,
                elements: [{
                        type: FormItemTypes.Box,
                        name: '',
                        display: 'flex',
                        justifyContent: 'space-between',
                        columnSize: 12,
                        alignItems: 'center',
                        mb: 0.5,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                children: 'Total taxes (₹)',
                                columnSize: 0,
                                fontSize: 'sm',
                                color: 'text.secondary',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.IconButton,
                                name: '',
                                children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                    color: "primary",
                                    sx: {
                                        height: 20,
                                        width: 20
                                    }
                                }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                columnSize: 0,
                                sx: {
                                    p: 0
                                },
                                setFieldProps: function () {
                                    return {
                                        disabled: false
                                    };
                                },
                                onClick: function (e, state) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: TaxDetailsPopup,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        px: 0.5,
                                                        width: {
                                                            xs: '100%'
                                                        },
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                },
                                                anchor: 'bottom'
                                            },
                                            componentProps: {
                                                data: state
                                            }
                                        }));
                                        return [2 /*return*/];
                                    });
                                }); },
                                unsubscribeFormChange: true
                            }]
                    }, {
                        type: FormItemTypes.NumberInput,
                        name: 'Totaltaxes',
                        label: '',
                        columnSize: 0,
                        disabled: true,
                        sx: {
                            p: 0
                        },
                        valueGetter: function (formValues, field) {
                            var _formValues$SavedPric6;
                            var totalTax = 0;
                            formValues === null || formValues === void 0 || (_formValues$SavedPric6 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric6 === void 0 || (_formValues$SavedPric6 = _formValues$SavedPric6.Taxes) === null || _formValues$SavedPric6 === void 0 || _formValues$SavedPric6.forEach(function (taxItem) {
                                totalTax += taxItem.TaxComponentAmount;
                            });
                            var displayValue = totalTax > 0 ? totalTax.toFixed(2) : 0;
                            return displayValue;
                        }
                    }]
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'PauseReasonId',
                label: 'Pause Reason',
                getListData: pauseReasonListAPICall,
                apiRequest: {
                    SystemName: "JobCardDetail"
                },
                apiKey: 'PauseReasonData',
                displayExpr: 'Name',
                valueExpr: 'id',
                xs: 12,
                setFieldProps: function (formValues) {
                    return {
                        disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) !== StatusEnum.Pause
                    };
                },
                validator: function (value, state) {
                    var message = '';
                    if (!value)
                        return message;
                    switch (state === null || state === void 0 ? void 0 : state.StatusName) {
                        case StatusEnum.Pause:
                            if (!value)
                                return "You cannont leave 'Pause Reason' blank since it is mandatory.";
                            break;
                        default:
                            if (value)
                                return "You cannot set 'Pause Reason' as status is not pause.";
                            break;
                    }
                    return message;
                }
            }, {
                type: FormItemTypes.TextInput,
                name: 'PauseRemarks',
                label: 'Pause Remarks',
                minRows: 3,
                value: null,
                multiline: true,
                xs: 12,
                setFieldProps: function (formValues, currValue, field) {
                    return {
                        disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) !== StatusEnum.Pause
                    };
                },
                validator: function (value, state) {
                    var message = '';
                    if (!value)
                        return message;
                    switch (state === null || state === void 0 ? void 0 : state.StatusName) {
                        case StatusEnum.Pause:
                            if (!value)
                                return "You cannont leave 'Pause remark' blank since it is mandatory.";
                            if ((value === null || value === void 0 ? void 0 : value.length) > 200) {
                                return "Maximum allowed limit is 200";
                            }
                            else {
                                return '';
                            }
                        default:
                            if (value)
                                return "You cannot set 'Pause Remark' as status is not pause.";
                            break;
                    }
                    return message;
                }
            }, {
                type: FormItemTypes.TextInput,
                name: 'Remarks',
                label: 'Remark :',
                minRows: 3,
                value: null,
                multiline: true,
                xs: 12
            }, {
                type: FormItemTypes.Box,
                name: '',
                // display: 'flex',
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Box,
                        name: '',
                        display: 'flex',
                        justifyContent: 'space-between',
                        columnSize: 12,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                value: 'Amount (₹)',
                                columnSize: 0,
                                color: 'text.secondary',
                                fontSize: 'sm',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.Button,
                                name: '',
                                variant: 'text',
                                children: 'Ratio',
                                columnSize: 0,
                                sx: {
                                    pt: 0
                                },
                                onClick: function (e, formValues, api) {
                                    handleRatioDetailsPopup(formValues);
                                },
                                setFieldProps: function (formValues, currValue) {
                                    var _formValues$RatioBill;
                                    return {
                                        disabled: false,
                                        sx: {
                                            display: ((_formValues$RatioBill = formValues.RatioBilling) === null || _formValues$RatioBill === void 0 ? void 0 : _formValues$RatioBill.length) > 0 ? 'inline-flex' : 'none',
                                            pt: 0
                                        }
                                    };
                                }
                            }]
                    }, {
                        type: FormItemTypes.TextInput,
                        name: 'Amount',
                        label: '',
                        value: null,
                        xs: 12,
                        disabled: true
                    }]
            },
            // {
            //     type: FormItemTypes.NumberInput,
            //     name: 'Price',
            //     label: 'Amount',
            //     value: null,
            //     xs: 12,
            // },
            {
                type: FormItemTypes.SearchSelect,
                name: 'StatusId',
                label: 'Status',
                validator: function (value, state) {
                    var message = '';
                    if (!value)
                        return "You cannont leave 'Status' blank since it is mandatory.";
                    else if ((state === null || state === void 0 ? void 0 : state.StatusName) === StatusEnum.Awaiting) {
                        message = '';
                    }
                    else if (!(state !== null && state !== void 0 && state.HSNSACCode)) {
                        message = GridValidations.SAC_REQUIRED;
                    }
                    else if (!(state !== null && state !== void 0 && state.TechnicianId) && (state === null || state === void 0 ? void 0 : state.StatusName) !== StatusEnum.Awaiting) {
                        message = GridValidations.MECHANIC_NOT_ALLOCATED;
                    }
                    else if (!(state !== null && state !== void 0 && state.ServiceTypeName) && (state === null || state === void 0 ? void 0 : state.StatusName) !== StatusEnum.Awaiting) {
                        message = GridValidations.JOB_TYPE_REQUIRED;
                    }
                    return message;
                },
                // apiKey: JobCardKeys.LabourStatusList,
                displayExpr: 'Name',
                valueExpr: 'id',
                getListData: getWorkDistributionStatusList,
                apiRequest: {
                    SystemName: 'JobCardDetail'
                },
                valueSetter: function (formValues, currValues) {
                    var _currValues$DisplayNa, _currValues$id;
                    var serviceStartDateTime;
                    var serviceEndDateTime;
                    if ((currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Start) {
                        serviceStartDateTime = new Date();
                        serviceEndDateTime = null;
                    }
                    else if (((currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Completed || (currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Pause) && !(formValues !== null && formValues !== void 0 && formValues.ServiceStartDateTime)) {
                        serviceStartDateTime = new Date();
                        serviceEndDateTime = new Date();
                    }
                    else if ((currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Awaiting) {
                        serviceStartDateTime = null;
                        serviceEndDateTime = null;
                    }
                    else {
                        serviceStartDateTime = formValues === null || formValues === void 0 ? void 0 : formValues.ServiceStartDateTime;
                        serviceEndDateTime = (currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Completed || (currValues === null || currValues === void 0 ? void 0 : currValues.Key) === StatusEnum.Pause ? new Date() : null;
                    }
                    return _objectSpread(_objectSpread({}, formValues), {}, {
                        StatusName: (_currValues$DisplayNa = currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName) !== null && _currValues$DisplayNa !== void 0 ? _currValues$DisplayNa : '',
                        StatusId: (_currValues$id = currValues === null || currValues === void 0 ? void 0 : currValues.id) !== null && _currValues$id !== void 0 ? _currValues$id : null,
                        StatusKey: currValues === null || currValues === void 0 ? void 0 : currValues.Key,
                        PauseRemarks: (currValues === null || currValues === void 0 ? void 0 : currValues.Key) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseRemarks,
                        PauseReasonId: (currValues === null || currValues === void 0 ? void 0 : currValues.Key) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseReasonId,
                        PauseReasonName: (currValues === null || currValues === void 0 ? void 0 : currValues.Key) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseReasonName,
                        ServiceStartDateTime: serviceStartDateTime,
                        ServiceEndDateTime: serviceEndDateTime
                    });
                },
                value: null,
                xs: 12
            }
            // only UAT v2.5
            // {
            //     type: FormItemTypes.Box,
            //     name: '',
            //     display: 'flex',
            //     justifyContent: 'end',
            //     gap: '16px',
            //     columnSize: 12,
            //     elements: [
            //         {
            //             type: FormItemTypes.Button,
            //             name: '',
            //             variant: 'outlined',
            //             children: 'View more',
            //             columnSize: 0,
            //             setFormState: async (state) => {
            //                 const res = await dispatch(showSurface({
            //                     type: 'Drawer',
            //                     Component: LabourMoreDetailsPopup,
            //                     containerProps: {
            //                         anchor: 'bottom',
            //                         PaperProps: {
            //                             sx: {
            //                                 borderRadius: '8px 8px 0 0'
            //                             }
            //                         }
            //                     },
            //                     componentProps: {
            //                         data: state,
            //                         wpRequest: {
            //                             JobCardId: state?.JobCardId,
            //                             JobCardDetailId: state?.JobCardDetailId,
            //                         }
            //                     }
            //                 }));
            //                 if (res?.payload) {
            //                     console.log('result', res?.payload)
            //                     return {
            //                         ...res?.payload
            //                     }
            //                 }
            //             }
            //         }],
            // },
        ]
    }];
export var warrantyListElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 2,
        columnSpacing: 2,
        columnSize: 12,
        elements: [{
                type: FormItemTypes.SearchSelect,
                name: 'CasualFlagId',
                label: 'Casual flag :',
                value: null,
                //required: true,
                getListData: warrantyCasualFlagListAPI,
                apiKey: 'casualFlagList',
                valueExpr: 'CasualFlagId',
                displayExpr: 'Name',
                xs: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'CasualPartName',
                label: 'Casual part',
                value: null,
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'ServiceTypeId',
                label: 'Service type',
                getListData: warrantyServiceTypeListAPI,
                apiKey: 'warrantyServiceTypeList',
                displayExpr: 'DisplayName',
                valueExpr: 'ServiceTypeId',
                // getOptionLabel: (value: any) => (value?.DisplayName + " | " + value?.Code),
                value: null,
                xs: 12
                //required: true
            }, {
                type: FormItemTypes.CheckBox,
                name: 'IsApproved',
                label: 'Approved',
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'SupplierId',
                label: 'Vendor',
                getListData: GetOrganizationTypeListAPI,
                apiKey: 'getOrganizationTypeList',
                displayExpr: 'Name',
                valueExpr: 'OrganizationId',
                //required: true,
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'CustomerComplaintDefectId',
                label: 'Defect code & name',
                getListData: warrantyComplaintTypeGetComplaintsAPI,
                apiKey: 'warrantyDefect',
                displayExpr: 'ComplaintName',
                apiRequest: {
                    Name: "Part Defect Code"
                },
                valueExpr: 'id',
                //required: true,
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'CustomerComplaintFaultCodeId',
                label: 'Performance code & name',
                getListData: warrantyComplaintTypeGetComplaintsAPI,
                apiKey: 'warrantyPerformance',
                apiRequest: {
                    Name: "Fault Code"
                },
                displayExpr: 'ComplaintName',
                valueExpr: 'ComplaintId'
                //required: true,
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'CustomerVoiceId',
                label: 'VoC code & name',
                getListData: warrantyComplaintTypeGetComplaintsAPI,
                apiKey: 'warrantyCustomerVoice',
                apiRequest: {
                    Name: "Customer Complaint"
                },
                displayExpr: 'ComplaintName',
                valueExpr: 'ComplaintId',
                //required: true,
                value: null,
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'ActionTakenId',
                label: 'Action taken code & name',
                getListData: warrantyComplaintTypeGetComplaintsAPI,
                apiKey: 'warrantyActiontaken',
                apiRequest: {
                    Name: "Fault Code"
                },
                displayExpr: 'ComplaintName',
                valueExpr: 'ComplaintId',
                value: null,
                //required: true,
                columnSize: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'SA_WMObservation',
                label: 'SA/WM observation:',
                value: null,
                minLength: 200,
                multiline: true,
                minRows: 4,
                xs: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'Remarks',
                label: 'Remarks',
                minLength: 200,
                value: null,
                xs: 12
            }, {
                type: FormItemTypes.DatePicker,
                name: 'ASMActivityDate',
                label: 'ASM Activity Date',
                value: null,
                columnSize: 12
                //required: true
            }, {
                type: FormItemTypes.TextInput,
                name: 'ASMRemark',
                label: 'ASM remarks',
                value: null,
                columnSize: 12
                //required: true
            }, {
                type: FormItemTypes.TextInput,
                name: 'ASMStatus',
                label: 'ASM status',
                columnSize: 12
            }]
    }];
export var recallPartElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        spacing: 0,
        rowSpacing: 2,
        columnSpacing: 2,
        columnSize: 12,
        elements: [{
                type: FormItemTypes.Box,
                name: '',
                sx: {
                    bgcolor: 'secondary.50',
                    borderRadius: '8px',
                    border: '1px solid ',
                    borderColor: 'secondary.200'
                },
                padding: '8px 12px ',
                gap: '4px',
                display: 'flex',
                flexDirection: 'column',
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'sdas',
                        label: 'Recall name:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: '',
                        label: 'Recall code:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: '',
                        label: 'Part qty:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }]
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'ActionType',
                label: 'Action type',
                value: null,
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'Actiontaken',
                label: 'Action taken name & code',
                xs: 12
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'defect',
                label: 'Defect code & name',
                xs: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'Remarks',
                label: 'Remarks',
                value: null,
                xs: 12
            }, {
                type: FormItemTypes.TextInput,
                name: 'ASMStatus',
                label: 'ASM status',
                columnSize: 12
            }, {
                type: FormItemTypes.Attachment,
                name: '',
                label: 'Add attachment',
                value: null,
                columnSize: 5
            }]
    }];
export var recallLabourElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 2,
        columnSpacing: 2,
        columnSize: 12,
        elements: [{
                type: FormItemTypes.Box,
                name: '',
                sx: {
                    bgcolor: 'secondary.50',
                    borderRadius: '8px',
                    border: '1px solid ',
                    borderColor: 'secondary.200'
                },
                padding: '8px 12px ',
                gap: '4px',
                display: 'flex',
                flexDirection: 'column',
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'sdas',
                        label: 'Recall name:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: '',
                        label: 'Recall code:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: '',
                        label: 'Labour unit:',
                        value: '',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        spacing: 0,
                        justifyContent: 'space-between',
                        alignItems: 'end',
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                children: 'Status :',
                                columnSize: 0,
                                fontSize: 'sm',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.Chip,
                                name: '',
                                label: 'Active',
                                color: 'info',
                                columnSize: 0,
                                sx: {
                                    borderRadius: '6px'
                                }
                            }]
                    }]
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'LabourClaim',
                label: 'Labour claim',
                value: null,
                xs: 12
            }]
    }];
var PartAndlabourListData = function () {
    return /*#__PURE__*/ React.createElement(React.Fragment, null);
};
export default PartAndlabourListData;
